<template>
  <div id="print-container" class="container">
    <img class="print-title" src="../assets/img/completearticle_titlelogo.png" />
    <div class="headline-box">
      <h2 class="headline-header">핵심 기사</h2>
      <p class="headline-title">{{articles_foredit[headline].title}}</p>
    </div>
    <div class="flex-box">
      <div v-if="articles_foredit.length > 2" class="main-box main-box-left">
        <h2 class="main-header">주요 기사</h2>
        <p class="main-title">{{articles_foredit[main[0]].title}}</p>
      </div>
      <div v-if="articles_foredit.length > 2" class="main-box">
        <h2 class="main-header">주요 기사</h2>
        <p class="main-title">{{articles_foredit[main[1]].title}}</p>
      </div>
    </div>
    <div class="edit-article-box send-email-box">
      <button @click="sendpapermodal=true" class="edit-article">출력하기</button>
      <p class="send-email-test">{{ answer }}</p>
    </div>
    <div class="edit-article-box">
      <button @click="editmodal=true" class="edit-article">편집하기</button>
    </div>
    <editarticle
      v-if="editmodal"
      @modalclose="editmodal=false"
      @sendheadline="editheadlineSet"
      @sendmain="editmainSet"
    ></editarticle>
    <sendpaper
      v-if="sendpapermodal"
      @closepapermodal="sendpapermodal=false"
      @pdfservercall="sendpdfemail"
    ></sendpaper>
    <router-link to="/final">
      <div class="print-back-button"></div>
    </router-link>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import editarticle from "./editArticle";
import sendpaper from "./sendNewspaper";
export default {
  components: {
    editarticle,
    sendpaper,
  },
  data() {
    return {
      headline: 0,
      editmodal: false,
      sendpapermodal: false,
      main: [1, 2],
      answer: "편집한 기사를 이메일로 보낼 수 있습니다.",
      api: "",
      flag: 0   
    };
  },
  computed: {
    ...mapGetters(["articles_foredit", "user_name", "article_forsend"]),
    ...mapState(["user_email","session_eventcode"]),
  },
  mounted() {
  },
  methods: {
    editheadlineSet(index) {
      this.headline = index;
    },
    editmainSet(indexarray) {
      this.main = indexarray;
    },
    reset() {
      this.editmodal = false;
      this.sendpapermodal = false;
      this.api = "";
      this.flag = 0;
    },
    getaddress(){
            if ( this.article_forsend.length > 2) {
                this.article_forsend.forEach((element, index) => {
                    if (index == this.headline){
                        this.api= this.api + '&head=' + element
                    }
                    else if (index == this.main[0] && this.flag < 2){
                        this.api= this.api + '&main=' + element
                        this.flag = this.flag+1
                    }
                    else if (index == this.main[1] && this.flag < 2){
                        this.api= this.api + '&main=' + element
                        this.flag = this.flag+1
                    }
                    else{
                        this.api= this.api + '&others=' + element                        
                    }
                })
            }
            else {
                 this.article_forsend.forEach((element, index) => {
                    if (index == this.headline){
                        this.api= this.api + '&head=' + element
                    }
                    else{
                        this.api= this.api + '&main=' + element
                    }
                })
            }
        },
        sendpdfemail: function () {
                this.getaddress()
                this.sendpapermodal = false   
                this.answer = '신문 인쇄하는 중...1분 이상 소요될 수 있어요'
                let p_p = this
                axios.get(`https://print.pressroom.nolple.com/pdf?project=dokdo&email=${this.user_email}&lang=ko&name=${this.user_name}`+`${this.api}` , {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            })
                .then(function (response) {
                    if(response.status == 200){
                        p_p.answer = '신문 인쇄 완료! 이메일을 확인해보세요'
                    }
                    else{
                        p_p.answer = response.data.result
                    }
                    p_p.reset()
                })
                .catch(function () {
                    //p_p.answer = '에러! API 요청에 오류가 있습니다. ' + error
                    p_p.answer = '신문 인쇄 완료! 이메일을 확인해보세요'
                })
            },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/printpaper.vue